// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2W17L","title":"Images90_title__3CSQY","images":"Images90_images__1M0Ua"};